import { capitalizeFirstLetter } from "@/assets/js/utils/functions";
import classNames from "classnames";
import { useState } from "react";

const CollapsibleSummary: React.FC<{ title: string; price:string; image:string; itemsLength:number}> = ({
    title,
    price,
    image,
    children,
    itemsLength
  }) => {
    const [showContent, setShowContent] = useState(false);
    const transition = "transition-all ease-out duration-300";
  
    const accordionClasses = classNames(transition, {
      "max-h-0 overflow-hidden": !showContent,
      "max-h-auto pb-4 space-y-3.75": showContent,
    });
  
    return (
      <div className="border border-grey-border border-opacity-50 rounded-15 relative">
        <div
          className={`p-4 flex flex-col ${itemsLength > 0 && "gap-y-2"}`}
        >
             <div className="py-2 px-3.75 flex bg-grey-fields-200 rounded-15 items-stretch cursor-pointer overflow-hidden">
            <figure
              className={`h-[44px] w-[44px] sm:h-12.5 sm:w-12.5 rounded-10 overflow-hidden flex-shrink-0`}
            >
              <img
                src={image}
                alt=""
                className="h-full w-full object-cover"
              />
            </figure>
            <div className="ml-3.75 flex flex-col gap-y-1 flex-1 overflow-hidden">
              <h5
                className={`text-black font-display font-bold overflow-hidden text-sm sm:text-1sm max-w-full whitespace-nowrap overflow-ellipsis `}
              >
                {capitalizeFirstLetter(title)} {itemsLength > 1 ? `and ${itemsLength - 1} other ${itemsLength < 3? "Item" : "Items"}` : ''} 
              </h5>
              <span
                className={`text-black-muted overflow-hidden text-xs sm:text-sm max-w-full whitespace-nowrap overflow-ellipsis `}
              >
                {price}
    
              </span>
            
            </div>
          </div>
          
        <div className={accordionClasses}>{children}</div>
        </div>
        <button type="button" onClick={() =>setShowContent(!showContent)} className="border-t text-black flex items-center justify-center text-sm md:text-1sm gap-1 border-grey-border border-opacity-50 w-full rounded-b-15 bg-grey-fields-200 py-3.75">
            View All Items
             {/* prettier-ignore */}
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={`transform ${
                showContent ? "" : "rotate-180"
              }`}>
                <path d="M17 14L12 9L7 14" stroke="#656565" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
      </div>
    );
  };
 export default CollapsibleSummary 